import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "@/components/vansha/PublicNav";
import { OrbitSeed, MoonPhases } from "@/components/vansha/Illustrations";

export default function Story() {
  return (
    <div className="min-h-screen bg-[#FBF4E8]" data-testid="story-page">
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-20 lg:py-32">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#F4A72C] mb-6">Our story</p>
        <h1 className="font-serif font-semibold text-5xl lg:text-6xl leading-[1.05]" data-testid="story-title">A quiet<br /><em className="text-[#E8552B]">rebellion.</em></h1>
        <div className="mt-12 space-y-8 text-lg text-[#3D2E5C] leading-relaxed">
          <p>Every family, in every country, walks through the same door — the moment they realise a new life is coming.</p>
          <p>And yet, for something so universally sacred, the tools we're given feel oddly fragmented. A tracker app here. A WhatsApp group there. A folder of scans. A shoebox of letters. A camera roll of photos no one will ever organise.</p>
          <p className="font-serif text-3xl text-[#1B1533] italic">We believed families deserved better.</p>
          <p>Vansha was built as a single quiet room — one place where the journey lives, is remembered, and is shared with the people who matter. Not louder. Not more. Just <em>together</em>.</p>
        </div>
        <div className="my-16 flex justify-center"><OrbitSeed size={280} /></div>
        <div className="space-y-8 text-lg text-[#3D2E5C] leading-relaxed">
          <p>The name <em className="font-serif">Vansha</em> comes from Sanskrit — <em>lineage</em>, the unbroken thread of family across generations. It's what we hope to help you build.</p>
          <p>Not a family tree of names. A family <em>story</em> — heartbeat by heartbeat, moment by moment, letter by letter — that your child, and their children, can hold in their hands one day.</p>
          <p className="font-serif text-3xl text-[#1B1533] italic">Welcome to Vansha.</p>
        </div>
        <div className="mt-16 flex flex-wrap gap-4">
          <Link to="/register" className="bg-[#1B1533] text-white rounded-full px-8 py-4 font-medium hover:scale-105 transition-transform" data-testid="story-cta">Begin your Vansha</Link>
          <Link to="/features" className="rounded-full px-8 py-4 font-medium border border-[#F5E7CE] hover:border-[#1B1533] transition">See features</Link>
        </div>
      </section>
    </div>
  );
}
